/*
* css classes mapping
* */
export default {
  MENU: 'react-contexify',
  SEPARATOR: 'react-contexify__separator',
  ITEM: 'react-contexify__item',
  ITEM_DISABLED: 'react-contexify__item--disabled',
  ITEM_DATA: 'react-contexify__item__data',
  ITEM_ICON: 'react-contexify__item__icon',
  THEME: 'react-contexify__theme--',
  ANIMATION_WILL_ENTER: 'react-contexify__will-enter--',
  ANIMATION_WILL_LEAVE: 'react-contexify__will-leave--'
};



// WEBPACK FOOTER //
// ./src/cssClasses.js